import { I18nt } from 'utils';
import { FormFieldValidationRules } from 'utils/interfaces';
import 'config/languages';

export default {
	afiliado: [
		{ required: true, message: I18nt('campo_requerido') },
		{ max: 10, message: I18nt('maximo', { max: 10 }) },
	],
	dui: [
		{ len: 10, message: I18nt('len', { len: 9 }) },
		{ required: true, message: I18nt('campo_requerido') },
	],
} as FormFieldValidationRules;
